import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useMetadataPref } from '#hooks/useMetadataPref';
import { addNotification } from '#notifications/notificationsSlice';
import { useDispatch, useSelector } from '#redux';

import { subirBarco } from './subirBarco';

/**
 * Todo barco vive también en la nube (decisión del 4-nov-2026). Si el
 * presupuesto abierto aún no ha subido (se botó sin conexión, o se importó),
 * lo sube cifrado sin preguntar y avisa después. Sin conexión espera a que
 * vuelva; con el cofre cerrado no sube nada y Gavi lo dice. La copia de este
 * móvil no se toca nunca.
 */
export function SubidaAutomatica() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [id] = useMetadataPref('id');
  const [cloudFileId] = useMetadataPref('cloudFileId');
  const [budgetName] = useMetadataPref('budgetName');
  const conCuenta = useSelector(state => Boolean(state.user.data?.userId));
  // Una subida a la vez, y el aviso del cofre una sola vez por barco.
  const enMarcha = useRef(false);
  const avisadoCofre = useRef<string | null>(null);

  useEffect(() => {
    if (!id || cloudFileId || !conCuenta) {
      return;
    }
    const avisar = (message: string) =>
      dispatch(addNotification({ notification: { type: 'message', message } }));
    const intentarSubir = async () => {
      if (enMarcha.current) {
        return;
      }
      enMarcha.current = true;
      const { error } = await subirBarco(dispatch, id).finally(() => {
        enMarcha.current = false;
      });
      if (!error) {
        avisar(
          t(
            '«{{name}}» is now in the cloud too, encrypted. You can open it on your other devices.',
            { name: budgetName },
          ),
        );
      } else if (error === 'cofre-cerrado' && avisadoCofre.current !== id) {
        avisadoCofre.current = id;
        avisar(
          t(
            '«{{name}}» stays on this phone for now: I will upload it encrypted to the cloud when you sign in with your Rumbo password.',
            { name: budgetName },
          ),
        );
      }
    };
    void intentarSubir();
    window.addEventListener('online', intentarSubir);
    return () => window.removeEventListener('online', intentarSubir);
  }, [id, cloudFileId, conCuenta, budgetName, dispatch, t]);

  return null;
}
